import { render, staticRenderFns } from "./WalkathonCreate.vue?vue&type=template&id=65e8aa2d&scoped=true"
import script from "./WalkathonCreate.vue?vue&type=script&lang=js"
export * from "./WalkathonCreate.vue?vue&type=script&lang=js"
import style0 from "./WalkathonCreate.vue?vue&type=style&index=0&id=65e8aa2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e8aa2d",
  null
  
)

export default component.exports